import Vue from 'vue';
import report from '@/components/card/report.vue';
import publish from '@/components/card/publish.vue';
import confirm from '@/components/custom/confirm.vue';

function getComp() {
  return {
    report,
    publish,
    confirm,
  };
}
const resultEl = {};
export function openReport(type, params) {
  params = params || {};
  const vueObj = getComp();
  const Task = Vue.extend(vueObj[type]);
  const taskvm = new Task({ data: { ...params } });
  resultEl[type] = taskvm.$mount().$el;
  document.body.appendChild(resultEl[type]);
}
export function removeReport(type) {
  if (resultEl[type]) {
    document.body.removeChild(resultEl[type]);
    delete resultEl[type];
  }
}
